/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { produce } from "immer";
import { createReducer } from "react-use";
import { FormReducer } from "./form-reducer";
import { getFormReducerState } from "./form-reducer-state";
import { apiPersistReducerMiddleware } from "./reducer-middleware/api-persist.reducer-middleware";
// import { loggerReducerMiddleware } from "./reducer-middleware/logger.reducer-middleware";

// create custom reducer with middleware
const useCustomReducer = createReducer(
    // loggerReducerMiddleware,
    apiPersistReducerMiddleware,
);

/** @type {typeof FormReducer} */
const immerFormReducer = produce(FormReducer);

/**
 * @returns {[FormReducerState, import('react').Dispatch<FormReducerAction>]}
 */
export function useFormReducer () {
    return useCustomReducer(immerFormReducer, null, getFormReducerState);
}
